import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  AbstractControl
} from "@angular/forms";
import swal from "sweetalert2";
import { Router } from "@angular/router";
import { Constants } from "@shared/constants/app.constants";
import { AccountService } from "@app/feature/external/account/shared/services/account.service";
import { TechBuyerService } from "@app/feature/main/tech-buyer/shared/services/tech-buyer.service";
import {
  TechBuyerProfile,
  TechBuyerDetails
} from "../shared/models/tech-buyer-profile-model";
import { TechBuyerOrganization } from "../shared/models/tech-buyer-organization-model";
import { MasterDataService } from "@shared/services/master-data.service";
import * as _ from "lodash";
import { GeographicResponsibilityService } from "@app/shared/services/geographic-responsibility.service";
import { DataService } from "@app/feature/main/roles-shared/services/data.service";
import { Title } from "@angular/platform-browser";
declare var $: any;
declare var window: any;
@Component({
  selector: "app-company-details",
  templateUrl: "./company-details.component.html",
  styleUrls: ["./company-details.component.css"],
  providers: [AccountService]
})
export class CompanyDetailsComponent implements OnInit {
  @Output() companyDetailsUpdated = new EventEmitter();
  userId = "";
  userEmail = "";
  techBuyerOrganization = new TechBuyerOrganization();
  geographies = [];
  countries = [];
  itBudgetData = [];
  revenuesData = [];
  employeeSizesData = [];
  industryData = [];
  techBuyerOrganizationForm: FormGroup;
  companyDetailsSubmitted = true;
  organizations = [];
  organizationNames = [];
  organization: any = {};
  geographicData = [];
  org = "";
  map = new Map();
  geographicresponsibily: any = {};
  completeAllOrganizationList: any = [];
  selectedCountryList: any = [];
  geoTitle: string;
  modifiedTechBuyerOrganization = new Object();
  researchData: any = { ratings: 0 };
  researchId;
  userRole;
  dropdownSettings = {
    singleSelection: false,
    text: "Select Countries",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    enableSearchFilter: true,
    classes: "myclass custom-class",
    showCheckbox: true,
    labelKey: "countryName",
    badgeShowLimit: 2
  };
  lineOfBusinesses: any = [];
  jobTitles: any = [];

  constructor(
    public formBuilder: FormBuilder,
    private router: Router,
    private accountService: AccountService,
    private techBuyerService: TechBuyerService,
    private masterDataService: MasterDataService,
    private geoResponsiblityService: GeographicResponsibilityService,
    private titleService: Title
  ) {}

  ngOnInit() {
    this.initializeModal();
    this.getOrganizationsList();
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userId = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      ).userId;
      this.userEmail = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      ).email;
    }
    this.createForm();
    this.getGeoGraphicsList();
  }

  initializeModal() {
    this.getCountries();
    this.getIndustries();
    this.getRevenues();
    this.getItBudgets();
    this.getEmployeeSizes();
    this.checkBlacklistedDomain();
    this.getLineOfBusinesses();
    this.getJobTitles();
  }

  getCountries() {
    this.masterDataService.getCountries().subscribe(
      (response: any) => {
        this.countries = response;
      },
      error => {}
    );
  }

  getIndustries() {
    this.masterDataService.getIndustries().subscribe(
      (response: any) => {
        this.industryData = response;
      },
      error => {}
    );
  }
  getEmployeeSizes() {
    this.masterDataService.getEmployeeSizes().subscribe(
      (response: any) => {
        this.employeeSizesData = response.data;
      },
      error => {}
    );
  }

  getRevenues() {
    this.masterDataService.getRevenues().subscribe(
      (response: any) => {
        this.revenuesData = response.data;
      },
      error => {}
    );
  }

  getItBudgets() {
    this.masterDataService.getItBudgets().subscribe(
      (response: any) => {
        this.itBudgetData = response.data;
      },
      error => {}
    );
  }

  getLineOfBusinesses() {
    if (this.lineOfBusinesses.length < 1) {
      this.masterDataService.getLineOfBusinesses().subscribe(
        (response: any) => {
          this.lineOfBusinesses = response;
        },
        error => { }
      );
    }
  }

  getJobTitles() {
    if (this.jobTitles.length < 1) {
      this.masterDataService.getJobTitles().subscribe(
        (response: any) => {
          this.jobTitles = response;
        },
        error => { }
      );
    }
  }

  getOrganizations() {
    this.techBuyerService.getOrganizations().subscribe(
      (response: any) => {
        this.organizations = response;
        this.organizationNames = Array.from(
          this.organizations,
          (data: any) => data.name
        );

        this.map.clear();
        for (let i = 0; i < this.organizations.length; i++) {
          this.map.set(this.organizations[i].name, this.organizations[i].id);
        }
      },
      error => {}
    );
  }

  public handleStaticResultSelected(result) {
    this.org = result;
  }

  // check black listed domain list
  checkBlacklistedDomain() {
    if (!this.userEmail) {
      return;
    }
    this.accountService
      .checkBlockListDomain(this.userEmail, "tech_buyer")
      .subscribe(
        (response: any) => {
          this.prefilOrganizationName(response);
        },
        error => {}
      );
  }

  prefilOrganizationName(response) {
    if (response.statusCode === 200 && response.companyData.length > 0) {
      const companyList = _.map(response.companyData, "name");
      const companyName = companyList[0];
      this.techBuyerOrganizationForm.value.companyName = companyName;
      this.org = companyName;

      this.map.clear();
      for (let i = 0; i < this.organizations.length; i++) {
        this.map.set(this.organizations[i].name, this.organizations[i].id);
      }
    }
  }

  // organisation auto complete fixes
  getOrganizationsList() {
    this.accountService.getOrganizationsList().subscribe(
      (response: any) => {
        this.completeAllOrganizationList = _.map(response, "name");
        this.organizationNames = _.map(response, "name");
      },
      error => {}
    );
  }

  createForm() {
    this.techBuyerOrganizationForm = this.formBuilder.group({
      companyName: ["", [Validators.required]],
      country: ["", [Validators.required]],
      industry: ["", [Validators.required]],
      employeeSize: ["", [Validators.required]],
      globalRevenue: ["", [Validators.required]],
      itBudget: ["", [Validators.required]],
      jobTitle: ["", [Validators.required]],
      lob: ["", [Validators.required]]
    //  labelName: [""],
   //   geoCountry: [""],
     // geographic: [""]
    });

    $("#company-details").on("hidden.bs.modal", () => {
      this.techBuyerOrganizationForm.reset();
    });
  }

  submitCompanyDetails() {
   // const geoControl = this.techBuyerOrganizationForm.get("geographic");
   // const labelControl = this.techBuyerOrganizationForm.get("labelName");
   // console.log('this.techBuyerOrganizationForm.get("geographic")', this.techBuyerOrganizationForm.get("geographic"));
   /*  if (
      this.organization.geographic &&
      this.organization.geographic !== "custom"
    ) {
      this.geographicresponsibily = {
        "title": this.geoTitle,
        "type": "general"
      }
      console.log('organization.geographic', this.organization.geographic)
      labelControl.setValidators(null); */
   /*  } else if (
      this.organization.geographic &&
      this.organization.geographic === "custom"
    ) {
      if (this.techBuyerOrganizationForm.value.labelName) {
        this.geographicresponsibily = {
          "title": this.techBuyerOrganizationForm.value.labelName,
          "type": "custom",
          "countryIds": this.selectedCountryList.map(data => data.id)

        }
        geoControl.setValidators(null);
      }
    } */
  //  geoControl.updateValueAndValidity();
   // labelControl.updateValueAndValidity();
    if (
      this.techBuyerOrganizationForm.valid &&
      this.techBuyerOrganizationForm.dirty
    ) {
      if (this.map.has(this.org)) {
        this.modifiedTechBuyerOrganization = Object.assign(
          { organizationId: this.map.get(this.org) },
          this.techBuyerOrganization
        );
      } else {
        this.modifiedTechBuyerOrganization = Object.assign(
          { organizationName: this.org },
          this.techBuyerOrganization
        );
      }

      this.companyDetailsSubmitted = false;
     /*  this.modifiedTechBuyerOrganization[
        `geographicalResponsibility`
      ] = this.geographicresponsibily; */
      this.techBuyerService
        .updateBuyerCompanyDetails(
          this.userId,
          this.modifiedTechBuyerOrganization
        )
        .subscribe(
          response => {
            console.log('company details added')

            swal({
              title: "Success!",
              text: "Company Information Updated!",
              type: "success",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "OK",
              confirmButtonClass: "btn adjust-swal-button",
              buttonsStyling: false
            }).then(result => {
              
              if (result.value) {
                console.log('clicked on OK')
                this.navigateToSurvey();
              }
            });
            window.scroll(0, 0);
            this.techBuyerOrganizationForm.markAsPristine();
            this.companyDetailsUpdated.emit("Updated");
            this.companyDetailsSubmitted = true;
          },
          error => {
            this.companyDetailsSubmitted = true;
          }
        );
    } else {
      this.validateAllFormFields(this.techBuyerOrganizationForm);
    }
  }

  navigateToSurvey(){
  const isFromHome = localStorage.getItem('isFromHome');
    //if (this.userRole === 'tech-buyer' && isFromHome === 'true'){
    this.researchData.surveyId = window.sessionStorage.getItem("currentSurveyId");
    this.researchData.id = window.sessionStorage.getItem("researchDocumentId");
    console.log('company details added', this.researchData.id, this.researchData.surveyId);
    this.researchId = this.researchData.id;
    this.router.navigate([`tech-buyer/survey/${this.researchId}`]);
   
    this.titleService.setTitle('Survey Started: ' + this.researchData.title || 'Ecosystm');
    var _hsq = window._hsq = window._hsq || [];
     _hsq.push(["trackEvent", {
      id: this.researchData.title,
      value : this.researchData.title
      }]); 
    _hsq.push(['trackPageView'])
    _hsq.push(['refreshPageHandlers']);
    //}
  }

  getTechBuyerDetails() {
    this.techBuyerService
      .getTechBuyerDetails(this.userId)
      .subscribe((response: any) => {
        console.log('The response is', response);
        const modifiedUserDetails = Object.assign(
          JSON.parse(window.sessionStorage.getItem("userDetails")),
          { organization: response.organization },
          { techBuyerOrganization: response.techbuyerOrganization }
        );
        window.sessionStorage.setItem(
          "userDetails",
          JSON.stringify(modifiedUserDetails)
        );
        if (window.localStorage.getItem("rememberMeStatus")) {
          if (window.localStorage.getItem("rememberMeStatus") === "true") {

            window.localStorage.setItem(
              "userDetails",
              JSON.stringify(modifiedUserDetails)
            );
          }
        }
      });
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
  //georesposibilty code
  getGeoGraphicsList() {
    this.geoResponsiblityService.getGeographicList().subscribe(
      (resp: any) => {
        this.geographicData = resp.data;
      },
      error => {}
    );
  }
  getCountryListForSelectedGeoResp(id) {
    if (id !== "custom" && id && id !== "undefined") {
      this.geoResponsiblityService.getCountryListBygeoId(id).subscribe(
        (resp: any) => {
          const a_map = resp.countries.reduce(
            (acc, value) =>
              Object.assign({}, acc, { [value.countryId]: value }),
            {}
          );
          const uniques = this.countries.filter(o => !!a_map[o.id]);
          this.selectedCountryList = uniques.map(obj => {
            obj.itemName = obj.countryName;
            return obj;
          });
          this.geoTitle = this.geographicData.find(
            data => data.id === id
          ).title;
        },
        err => {}
      );
    } else {
      this.selectedCountryList = [];
      this.geoTitle = null;
    }
  }
  showCountryList(value) {
    if (value) {
      this.getCountryListForSelectedGeoResp(value);
    }
  }

  schangeDropdownState(className,selectClassName) {
    document.querySelectorAll(className).forEach(el => {
      if (
        this.organization.geographic &&
        this.organization.geographic !== "custom"
      ) {
        el.classList.remove("enable-country");
        el.classList.add("disabled-country");
      } else {
        el.classList.remove("disabled-country");
        el.classList.add("enable-country");
      }
    });
    document.querySelectorAll(selectClassName).forEach(el => {
      if (
        this.organization.geographic &&
        this.organization.geographic !== "custom"
      ) {
        el.classList.add("hide-close-btn");
      } else {
        el.classList.remove("hide-close-btn");
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/tech-buyer/company-details/company-details.component.ts